export default "__VITE_ASSET__f124457f__"